<email-layout>
  <ng-container logo>
    <email-recruitee-logo />
  </ng-container>

  <ng-container header>
    <email-message-header
      [header]="data().title"
      [subheader]="data().p1"
      [imageUrl]="data().avatar_url"
      [imageAlt]="data().title"
    />
  </ng-container>

  <ng-container body>
    <email-text [contents]="data().p2 | mailgunMarkAsHtml" />
    <email-margin [height]="28" />
    <email-button [href]="data().url" [label]="data().url" theme="accent" [inline]="true" />
  </ng-container>

  <ng-container footer>
    <email-text
      [contents]="data().footer.text"
      color="light"
      presetName="inline"
      size="small"
    />&nbsp;
    <email-link
      [label]="data().footer.label"
      [href]="data().footer.href"
      [target]="data().footer.target"
      [textOpts]="{ size: 'small', color: 'light' }"
      textPreset="inline"
    />
  </ng-container>
</email-layout>
